/**
 * आपके अंक (N-PAC, 31 Oct 2026, the field team leaderboard): this week's points and place of the surveyor
 * signed in on this phone. Online only; nothing shows without network or for other logins.
 */
import { useEffect, useState } from "react";
import { useApp, useSession } from "../ui/context";

export function MyPoints() {
  const { app, t } = useApp();
  const { user } = useSession();
  const [d, setD] = useState<{ points: number; rank: number | null; of: number } | null>(null);
  useEffect(() => {
    if (user?.role !== "surveyor") return;
    let off = false;
    app
      .online((api, aid) => api.myPoints(aid))
      .then((r) => !off && r.me && setD({ points: r.me.points, rank: r.me.rank, of: r.of }))
      .catch(() => undefined);
    return () => {
      off = true;
    };
  }, [app, user?.role]);
  if (!d) return null;
  return (
    <div className="my-points" data-testid="my-points">
      <span className="mp-ic" aria-hidden>
        🏆
      </span>
      <span>
        <b>{t.mpPoints(d.points)}</b>
        <small>{d.rank ? t.mpRank(d.rank, d.of) : t.mpStart}</small>
      </span>
    </div>
  );
}
